import Image from 'next/image'

const ResponsiveImage = ({ src, alt, width, height, blur, priority = false, sizes = '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw' }) => {
  return (
    <div className='relative !w-full'>
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
        placeholder={blur ? 'blur' : 'empty'}
        sizes={sizes}
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  )
}

export default ResponsiveImage